module.exports = __webpack_public_path__ + "img/icon-msds-kosha.4d9ba0c9.svg";